import AppModal, { AppModalProps } from "@/common/components/Modals/AppModal";
import AppModalContent from "@/common/components/Modals/AppModalContent";
import { useModalOpenStatus } from "@/common/hooks/modal/useModalOpenStatus";
import { ViewVariant } from "@/common/ts/layout";

import WheelOperationView, { WheelOperationViewProps } from "./WheelOperationView";

export interface OwnProps {
  viewProps: WheelOperationViewProps;
}
type Props = OwnProps & AppModalProps;

export function WheelOperationViewModal({ viewProps, ...modalProps }: Props) {
  const openStatus = useModalOpenStatus(modalProps);

  return (
    <AppModal fullWidth maxWidth='lg' {...modalProps}>
      <AppModalContent>
        {openStatus.isOpen && (
          <WheelOperationView
            headerProps={{
              withLink: true,
              typographyProps: {
                variant: "h1",
              },
            }}
            {...viewProps}
            displayProps={{
              viewVariant: ViewVariant.Modal,
              closeInHeader: true,
              ...viewProps?.displayProps,
            }}
            onDelete={() => {
              modalProps.onClose?.({}, "escapeKeyDown");
              viewProps.onDelete?.();
            }}
            onClose={() => {
              modalProps.onClose?.({}, "escapeKeyDown");
              viewProps.onClose?.();
            }}
          />
        )}
      </AppModalContent>
    </AppModal>
  );
}
